<script>
export default {
  created() {
    this.$oidc.signinRedirect();
  },
};
</script>

<template>
  <div class="ezid-logout-callback-page-wrapper"></div>
</template>